import { render, staticRenderFns } from "./WebPartFormDesigner.vue?vue&type=template&id=71ab8ce2&scoped=true&"
import script from "./WebPartFormDesigner.vue?vue&type=script&lang=js&"
export * from "./WebPartFormDesigner.vue?vue&type=script&lang=js&"
import style0 from "./WebPartFormDesigner.vue?vue&type=style&index=0&id=71ab8ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab8ce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ab8ce2')) {
      api.createRecord('71ab8ce2', component.options)
    } else {
      api.reload('71ab8ce2', component.options)
    }
    module.hot.accept("./WebPartFormDesigner.vue?vue&type=template&id=71ab8ce2&scoped=true&", function () {
      api.rerender('71ab8ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartFormDesigner.vue"
export default component.exports